import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getShipmentWithMapping } from 'utils/ShipmentWebAPIUtils';
/**
 * Hook to fetch a shipment by ID using React Query.
 * Useful for on-demand fetching when editing charges.
 */
export function useShipmentById(shipmentId, options = {}) {
    const { enabled = true, staleTime = 30000 } = options;
    return useQuery({
        queryKey: ['getShipment', shipmentId, {}],
        queryFn: () => {
            if (!shipmentId) {
                throw new Error('Shipment ID is required');
            }
            return getShipmentWithMapping(shipmentId);
        },
        enabled: enabled && Boolean(shipmentId),
        staleTime,
    });
}
/**
 * Hook to imperatively fetch a shipment by ID.
 * Returns a function that can be called to fetch the shipment on-demand.
 */
export function useFetchShipment() {
    const queryClient = useQueryClient();
    const fetchShipment = async (shipmentId) => {
        if (!shipmentId) {
            return null;
        }
        try {
            const shipment = await queryClient.fetchQuery({
                queryKey: ['getShipment', shipmentId, {}],
                queryFn: () => getShipmentWithMapping(shipmentId),
                staleTime: 30000,
            });
            return shipment;
        }
        catch (error) {
            console.error('Error fetching shipment:', error);
            return null;
        }
    };
    return { fetchShipment };
}
